export default "__VITE_ASSET__CLkM31dC__"